import React, { useEffect } from "react";
import Header from '../components/header'; 
import Footer from '../components/footer'; 
import FloatingSocial from '../components/floating_social'; 
import AOS from "aos";
import "aos/dist/aos.css";

const Dinein = () => {

useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  return (
    <div>
      <Header />
      
<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/9.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Our Dine in</div>
					</div>
				</div>
			</div>
		</div>
	</div>

 <section className="py-5 bg-light position-relative overflow-hidden">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Content */}
          <div 
            className="col-lg-6 mb-5 mb-lg-0"
            data-aos="fade-right"
          >
            <span className="badge bg-gradient px-3 py-2 mb-3 fs-6 shadow-sm">
              OUR DINE IN
            </span>

            <h3 className="fw-bold mb-4">
              Pahadi Restaurant –  <span className="text-primary">Flavours That Feel Like Home</span>
            </h3>

            <p className="text-muted fs-5">
             Located within Hotel Pahadi at Vedvyas, Rourkela, Pahadi Restaurant offers a delightful dining experience blending taste, tradition, and comfort. Whether you’re a hotel guest or a local food lover, the restaurant welcomes you with warm hospitality and mouth-watering dishes.
            </p>
            
            
            
          </div>

          {/* Right Image */}
          <div 
            className="col-lg-6 text-center"
            data-aos="fade-left"
          >
            <div className="position-relative">
              <img 
                src="img/27.jpeg" 
                alt="Hotel Room"
                className="img-fluid rounded-4 shadow-lg about-img"
              />
            </div>
          </div>
            </div>
            <br></br> <br></br>
            <section class="restaurant-section">

          <h5>Multi-Cuisine Dining Experience</h5>
          <p>
            From authentic Indian delicacies to popular global favourites, our menu is thoughtfully curated to satisfy every palate.
          </p>

          <h6>Main Course Specialties</h6>
          <ul>
            <li>North & South Indian dishes</li>
            <li>Tandoori and grilled delights</li>
            <li>Veg & Non-Veg special curries</li>
            <li>Rice varieties & breads</li>
            <li>Chef’s signature seasonal preparations</li>
          </ul>

          <p>
            Every dish is prepared using fresh ingredients and balanced spices to deliver rich and memorable flavours.
          </p>

          <h6>Sweets & Snacks Corner</h6>
          <p>
            Pahadi Restaurant is also known for its delightful sweets and snacks, perfect for light cravings or evening gatherings.
          </p>

          <h6>Sweet Delights</h6>
          <ul>
            <li>Traditional Indian sweets</li>
            <li>Freshly prepared desserts</li>
            <li>Festive special mithai</li>
            <li>Hot gulab jamun & rasgulla</li>
          </ul>

          <h6>Tasty Snacks</h6>
          <ul>
            <li>Samosa, kachori & pakora</li>
            <li>Cutlets & crispy starters</li>
            <li>Tea-time snacks</li>
            <li>Light bites for small gatherings</li>
          </ul>

          <p>
            Whether it’s a quick snack break or a sweet ending to your meal, our selection adds extra joy to your dining experience.
          </p>

          <h6>Relax & Unwind</h6>
          <p>
            With a pleasant ambiance and comfortable seating, Pahadi Restaurant is ideal for:
          </p>

          <ul>
            <li>Family dinners</li>
            <li>Business lunches</li>
            <li>Small celebrations</li>
            <li>Casual meet-ups</li>
            <li>Evening snack outings</li>
          </ul>

          <p>
            Enjoy great food, warm service, and a welcoming atmosphere — all under one roof at 
            <strong>Pahadi Restaurant, Vedvyas, Rourkela.</strong>
          </p>

        </section>
      </div>

      {/* Decorative Shape */}
      <div className="position-absolute top-0 end-0 opacity-25">
        <div className="bg-primary rounded-circle shape-circle"></div>
      </div>
    </section>

 
<br />
        <Footer />
        <FloatingSocial />
    </div>
  )
}

export default Dinein;